import { useEffect, useRef, useState } from 'react';

type Ttq1qnqReadyDialogProps = {
  open: boolean;
  countdownSeconds?: number;
  onClose: () => void;
};

export function Ttq1qnqReadyDialog({
  open,
  countdownSeconds = 3,
  onClose,
}: Ttq1qnqReadyDialogProps) {
  const [left, setLeft] = useState(countdownSeconds);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  const closedRef = useRef(false);

  useEffect(() => {
    if (!open) {
      closedRef.current = false;
      return undefined;
    }
    closedRef.current = false;
    let remaining = countdownSeconds;
    setLeft(remaining);
    const timer = window.setInterval(() => {
      remaining -= 1;
      setLeft(Math.max(0, remaining));
      if (remaining <= 0) {
        window.clearInterval(timer);
        if (!closedRef.current) {
          closedRef.current = true;
          onCloseRef.current();
        }
      }
    }, 1000);
    return () => window.clearInterval(timer);
  }, [countdownSeconds, open]);

  if (!open) return null;

  const handleClose = () => {
    if (closedRef.current) return;
    closedRef.current = true;
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/35 px-4">
      <div
        className="w-full max-w-xs rounded-xl border border-border bg-surface p-5 text-center shadow-xl"
        role="dialog"
        aria-modal
        aria-labelledby="ttq-1qnq-ready-title"
      >
        <p id="ttq-1qnq-ready-title" className="text-sm font-semibold text-ink">
          变式题已生成
        </p>
        <p className="mt-1 text-xs text-muted">即将关闭采集盘，并定位到新知识颗粒</p>
        <button
          type="button"
          className="mt-4 w-full rounded-lg bg-primary py-2.5 text-sm font-medium text-white hover:opacity-90"
          onClick={handleClose}
        >
          {left > 0 ? `关闭（${left}）` : '关闭'}
        </button>
      </div>
    </div>
  );
}
